import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import filter from '../../versa/filter.js';
import router from '../../versa/router.js';
import formset from '../../versa/formset.js';
import { flatten, deepen } from '../../versa/record.js';
import { notify, ask } from '../../versa/msgbox.js';
import pdf from '../../versa/pdf.js';
import view from '../views/replenishments.js';
import form from '../forms/replenishments.js';
import buildReplenishmentGeneratorForm from '../forms/replenishments-create-replenishment.js';
import * as types from '../types.js';

async function companyIdFromGridFilter(crud_)
{
	let f = crud_.filter;
	if (f && Object.keys(f).some(k => /^field-\d+$/.test(k)))
		f = await resolveFilterLabelsToIds(f, crud_.fieldspecs);
	for (let i = 0; i < 12; i++)
	{
		if (f[`field-${i}`] === 'company_id' && f[`value-${i}`])
			return String(f[`value-${i}`]).trim();
	}
	return null;
}

const replenishment_orders = function()
{

	let orders_crud = crud.create({
		async loadBaseData()
		{
			api.call(api.list_companies, this.queryAll()).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_warehouses, this.queryAll()).then((data) => db.set('warehouses', data).catch(error => notify(error)));
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data).catch(error => notify(error)));
		},
		async queryData(query)
		{
			return await api.call(api.list_replenishments, query);
		},
		insertRecord()
		{
			this.createReplenishment();
		},
		async editFilter() {
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data)).catch(() => {});
			filter.edit(this.applyFilter.bind(this), this.filter);
		},
		async applyFilter(data) {
			this.filter = data;
			api.call(api.list_locations, await this.queryFilteredForLocations()).then((data) => db.set('locations', data)).catch(() => {});
			this.loadPage(1);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_replenishment, ...JSON.parse(id));
			return flatten(_record, 'items');
		},
		async saveRecord(data, old_data)
		{
			data = deepen(data, 'items');
			let _record = {
				items: data.items.map(item => ({
					from_location_id: Number(item.from_location_id),
					to_location_id: Number(item.to_location_id),
					lot_company_id: item.lot_company_id,
					lot_id: Number(item.lot_id),
					product_id: Number(item.product_id),
					quantity_needed: Number(item.quantity_needed),
					quantity_moved: Number(item.quantity_moved)
				}))
			};
			if (old_data)
				return await api.call(api.update_replenishment, data.company_id, data.warehouse_id, data.id, _record);
			return await api.call(api.insert_replenishment, data.company_id, data.warehouse_id);
		},
		async createReplenishment()
		{
			const companyId = await resolveTenantCompanyId(this);
			if (!companyId)
			{
				notify('Não foi possível identificar o tenant: filtre por empresa, selecione uma linha, ou garanta dados na página.', 'Gerar ressuprimento');
				return;
			}
			const showResult = (resp) =>
			{
				notify(resp.id ? 'Ressuprimento criado' : 'Não há posições a ressuprir', 'Resultado');
				this.loadPage();
				fs.destroy();
			};
			const sendRequest = async (data) =>
			{
				const payload = data._payload && Object.keys(data._payload).length ? data._payload : null;
				await api.call(api.insert_replenishment, data.company_id, data.warehouse_id, payload).then(showResult);
			};
			let fs = formset.create(buildReplenishmentGeneratorForm(companyId), sendRequest);
			fs.init();
		},
		closeReplenishments()
		{
			const showResult = (resp) =>
			{
				notify(resp.count ? `Ressuprimentos finalizados: ${resp.count}` : 'Nenhum ressuprimento a finalizar', 'Resultado');
				this.loadPage();
			};
			const sendRequest = async () =>
			{
				let ids = await this.getSelectedIds(['company_id', 'warehouse_id', 'id']);
				await api.call(api.close_replenishments, { 'ids': ids }).then(showResult);
			};
			ask(`Encerrar ${this.getCount()} ressuprimentos?`, 'Baixar Ressuprimentos', (answer) =>
			{
				if (answer == 'Y')
					sendRequest();
			});
		},
		printReplenishmentOrders()
		{
			const showResult = async (resp) =>
			{
				this.clearGridSelection();
				if (resp?.pdf)
					pdf(resp.pdf);
			};
			const sendRequest = async () =>
			{
				let ids = await this.getSelectedIds(['company_id', 'warehouse_id', 'id']);
				await api.call(api.print_replenishment_orders, { 'ids': ids }).then(showResult);
			};
			ask(`Gerar ordem para ${this.getCount()} ressuprimentos?`, 'Ordem de Ressuprimento', (answer) =>
			{
				if (answer == 'Y')
					sendRequest();
			});
		},
	});

	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'warehouse_id', label: 'Armazém', types: [types.datalist()], placeholder: '', title: 'Armazém do estoque', store: 'warehouses', labels: ['name'] },
		{ index: 3, field: 'id', label: 'Ressuprimento', types: [types.number(0, 2)], placeholder: '0', title: 'Identificador do ressuprimento' },
		{ index: 4, field: 'created_on', label: 'Criação', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora de criação do ressuprimento' },
		{ index: 5, field: 'completed_on', label: 'Conclusão', types: [types.datetime()], placeholder: 'dd/mm/aaaa hh:mm:ss', title: 'Data e hora de conclusão do ressuprimento' },
	];

	let operations = [
		{ hash: '#goto-replenishment-rules', label: 'Regras&nbsp;min/máx' },
		{ hash: '#close-replenishments',	label: 'Baixar&nbsp;Ressuprimentos'	},
	];

	let reports = [
		{ hash: '#print-orders', 	label: 'Ordem&nbsp;de&nbsp;Ressuprimento' },
	];

	router.set('#close-replenishments', orders_crud.closeReplenishments.bind(orders_crud));
	router.set('#print-orders',	orders_crud.printReplenishmentOrders.bind(orders_crud));

	orders_crud.run(
		'replenishment-orders',
		'Ressuprimentos — ordens (LOG)',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		operations,
		reports
	);
};

export default replenishment_orders;
